export default "__VITE_ASSET__QYGCEI$H__"